import styled from 'styled-components'

export const EvixCardRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  width: 100%;
  align-items: start;
`


